import React, { createContext, useContext, useEffect, useState, FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { isSummaryTotalsAvailable as isSummaryTotalsAvailableService } from 'api/balanceTransaction/service';

const BankConfigContext = createContext({});

interface Props {
  children: (args: any) => ReactNode | ReactNode;
}

export const BankConfigProvider: FC<Props> = ({ children, ...props }) => {
  const [config, setConfig] = useState({});
  const authenticationId = useSelector((state) => state.auth?.user?.authenticationId);

  useEffect(() => {
    let subscription;

    if (authenticationId) {
      subscription = isSummaryTotalsAvailableService().subscribe(
        ({ data: { isSummaryTotalsAvailable } }) => {
          setConfig({
            ...config,
            isSummaryTotalsAvailable
          });
        },
        () => {
          setConfig({
            ...config,
            isSummaryTotalsAvailable: true
          });
        }
      );
    }

    return () => subscription?.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticationId]);

  return (
    <BankConfigContext.Provider value={config}>
      {typeof children === 'function' ? children({ bankConfig: config, ...props }) : children}
    </BankConfigContext.Provider>
  );
};

export const useBankConfig = () => useContext(BankConfigContext);

export default BankConfigProvider;
